import LeonardoContainer from './LeonardoContainer';

export default LeonardoContainer;